// extracted by mini-css-extract-plugin
module.exports = {"scroll":"category_scroll__2ATYf","light":"category_light__1MTxJ","dark":"category_dark__1dylF","back":"category_back__1sKhn"};